import Vue from 'vue'
import { dateFormat, dateFormatHU, dateTimeFormatHU, timeFormatHU } from './date-format'
import moneyFormat from './money-format'

export function registerAll() {
    Vue.filter('moneyFormat', moneyFormat.filter)
    Vue.filter('dateFormat', dateFormat)
    Vue.filter('dateFormatHU', dateFormatHU)
    Vue.filter('dateTimeFormatHU', dateTimeFormatHU)
    Vue.filter('timeFormatHU', timeFormatHU)
}
